<template>
  <privacy />
</template>
<script>
import Privacy from '@/components/privacy/index.vue'
export default {
  components: { Privacy }
}
</script>
